import React, { useState, useEffect } from 'react';
import Top from '../../Assets/arrow-up.png';
import '../../../src/style.css';

const BackToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    window.onscroll = () => {
      if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <button
      className={`back-to-top-btn ${isVisible ? 'visible' : 'hidden'}`}
      onClick={scrollToTop}
    >
      <img src={Top} alt="about" className="Top" />
    </button>
  );
};

export default BackToTopButton;
